import Responsive from './Responsive';
import Swiper from 'swiper';

module.exports = function() {
	const r = new Responsive();

	const wrapper = $('.slide_wrapper-card_list_hasimg');
	const target = '#js-slide-card_list_hasimg';
	let slide_obj = undefined;
	let slide_num = $(target).find('li').length;

	let slide_options = {
		speed:800,
		slidesPerView: 'auto',
		spaceBetween: 0,
		loop:true,
		nextButton: '.swiper-button-next-card_list_hasimg',
		prevButton: '.swiper-button-prev-card_list_hasimg',
		centeredSlides:true
	};

	$(window).on('resize load',function(){
		if(slide_num > 1 && !r.state()() && slide_obj == undefined){
			slide_obj = new Swiper(target,slide_options);
			$('.swiper-button-next-card_list_hasimg,.swiper-button-prev-card_list_hasimg').fadeIn(100);
		}
	}).on('resize',function(){
		if(r.state()() && slide_obj != undefined){
			slide_obj.destroy(false,true);
			slide_obj = undefined;
		}
	});
}



// WEBPACK FOOTER //
// ./dev/js/scripts/slide_card_list_hasimg.js